import { FileNode } from '@/interfaces/query-pad'
export default {
  namespaced: true,

  state: {
    selectedFileNode: {
      title: '/',
      isDraggable: false,
      isLeaf: false,
      isExpanded: true,
      folderPath: '/',
      children: []
    }
  },

  mutations: {
    setSelectedFileNode (state: any, node: FileNode) {
      state.selectedFileNode = node
    }
  }
}
